import { GetFootersQuery } from "@/apollo/generated/graphql"
import { menuNavigationClick } from "@/utils/gtm"
import styled from "@emotion/styled"
import { Box, List, ListItem, Typography } from "@mui/material"
import Link from "next/link"
import { extractMenuProperties, getNonUmbracoUrl } from "utils"
import { colors } from "../../theme/theme"
const StyledFooterMenuWrapper = styled(Box)`
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  gap: 60px;
  padding: 50px 60px;
  width: 100%;
`
const StyledListWrapper = styled(Box)`
  display: flex;
  flex-direction: column;
  gap: 20px;
`
const StyledList = styled(List)`
  display: flex !important;
  flex-direction: column;
  line-height: 1.7;
  width: 200px;
  a {
    text-decoration: none;
    color: ${colors.black};
    &:visited {
      color: ${colors.black};
    }
  }
`
const StyledListItem = styled(ListItem)`
  padding: 0;
`
const FooterDesktop = ({ data }: { data: GetFootersQuery }) => {
  const dataFooter = extractMenuProperties(data.footer_desktop as any)
  return (
    <StyledFooterMenuWrapper>
      {dataFooter.footerMenu?.map((item: any, index: number) => (
        <StyledListWrapper
          key={`footer-menu-${index}-${item.properties[0].propertyValue.value}`}
        >
          <Typography variant="h4">
            {item.properties[0].propertyValue.value}
          </Typography>
          <StyledList>
            {item.properties[1].propertyValue.blocks.map(
              (propertyItem: any, i: number) => {
                const { linkName, linkUrl } =
                  extractMenuProperties(propertyItem)
                return (
                  <StyledListItem key={i}>
                    <Link
                      target={linkUrl[0]?.target ?? ""}
                      href={getNonUmbracoUrl(linkUrl[0]?.url)}
                      prefetch={false}
                      onClick={() => {
                        menuNavigationClick({
                          menuType: "תפריט תחתון",
                          menuCategory1: linkName,
                          menuCategory2: item.properties[0].propertyValue.value,
                        })
                      }}
                    >
                      {linkName}
                    </Link>
                  </StyledListItem>
                )
              },
            )}
          </StyledList>
        </StyledListWrapper>
      ))}
    </StyledFooterMenuWrapper>
  )
}

export default FooterDesktop
